"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _icon_wrapper = _interopRequireDefault(require("./icon_wrapper"));
var _templateObject, _class, _FlagRwIcon;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Wrapper = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  display: inline-block;\n  overflow: hidden;\n  width: ", ";\n  height: ", ";\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.width;
});
var FlagRwIcon = (0, _mobxReact.observer)(_class = (_FlagRwIcon = /*#__PURE__*/function (_React$Component) {
  function FlagRwIcon() {
    _classCallCheck(this, FlagRwIcon);
    return _callSuper(this, FlagRwIcon, arguments);
  }
  _inherits(FlagRwIcon, _React$Component);
  return _createClass(FlagRwIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(Wrapper, {
        width: this.props.width
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100"
      }, /*#__PURE__*/_react["default"].createElement("g", {
        fill: "none"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#1DB5D7",
        d: "M0 0h100v54.6H0z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#F7F7F7",
        d: "M0 53.1h100v23.4H0z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#15945B",
        d: "M0 76.2h100V100H0z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#FAD300",
        d: "M0 52.6h100V76H0z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#E6BF00",
        d: "M50 10.9l1 9.7 3.8-9.1-1.8 9.7 6.1-7.7-4.4 8.8 8.1-5.6-6.7 7.1 9.3-3.1-8.5 5 9.8-.4-9.5 2.4 9.5 2.5-9.8-.4 8.5 5-9.3-3.1 6.7 7.1-8.1-5.6 4.4 8.8-6.1-7.7 1.8 9.7-3.8-9.1-1 9.7-1-9.7-3.8 9.1 1.8-9.7-6.1 7.7 4.4-8.8-8.1 5.6 6.7-7.1-9.3 3.1 8.5-5-9.8.4 9.5-2.5-9.5-2.4 9.8.4-8.5-5 9.3 3.1-6.7-7.1 8.1 5.6-4.4-8.8 6.1 7.7-1.8-9.7 3.8 9.1z"
      }))));
    }
  }]);
}(_react["default"].Component), _FlagRwIcon.defaultProps = {
  width: '20px'
}, _FlagRwIcon)) || _class;
var _default = exports["default"] = (0, _icon_wrapper["default"])(FlagRwIcon);